<template>
  <SmartRow>
    <SmartTitle
      heading="1"
      class="lg:col-12 px-2 mb-0 mt-0">
      Nuvem
    </SmartTitle>
      <SmartRow class="lg:col-12 mt-4">
        <SmartButtonDash
          v-for="(report, index) in nuvemCards"
          :key="index"
          v-bind="report"
          class="lg:col-4 text-left my-2 flex flex-wrap"
        />
      </SmartRow>
  </SmartRow>
</template>
<script>

import {  mapActions } from 'vuex';
import BrowserStorage from '@/services/browser-storage';
import { nuvem } from 'endPoints';
 
// @flow
export default {
  data() {
    return {
      nuvemCards: [
        {
          title: 'Nuvem TIM',
          description: 'Acesso ao sistema de Nuvem TIM',
          buttonText: 'Acessar o sistema',
          action: () => {
            var baseURL = process.env.VUE_APP_PROJETO_NUVEM;
            var token = BrowserStorage.get('token');
            var url = baseURL + nuvem + "?token=" + token;
            var link = document.createElement('a');
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();  

          }
        },
      ]
    };
  },
  methods: {
    
  }
};
</script>
